<template>
  <div class="article page-404" v-if="$root.dataReady">
    <header class="heading">
      <div class="container">
        <div class="text">
          <h2>Page not found</h2>
        </div>
      </div>
    </header>
    <div class="container">
      <div class="post-content page-404-content">
      	<p>Sorry - the page you requested appears to have been moved, deleted, or does not exist on this site. Please use the navigation above or go to the home page <a href="/">here</a>.</p>
      	<p>We apologies for any inconvenience.</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: '404-page',
    data() {
      return {
        page: null
      }
    },
    created: function() {
      this.$root.headeriswhite = false;
      this.$root.dataReady = true;
    },
    mounted: function() {
    },
    methods: {
      setTitle: function(title){
        document.title = "Page not found - Weber Shandwick";
      }
    }
  }
</script>


// WEBPACK FOOTER //
// 404.vue?509e3a37